import React, { Suspense } from 'react'
import Cards from "./components/Cards.jsx";
import LoadingSpinner from './components/LoadingSpinner'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";


const Projects = React.lazy(() => import( './components/Projects'))
const Curiosity = React.lazy(()=> import('./components/Curiosity'))
const Introduction = React.lazy(() => import('./components/Introduction'))
const Contact = React.lazy(()=> import ('./components/Contact'))
// const Cards = React.lazy(()=> import('./components/Cards.jsx'))

function App() {
  
  return (
    
    <div className="App">
      <Router>
      <Suspense fallback = {<LoadingSpinner/>} >
        <Switch>
          <Route exact path = '/' >
            <Introduction />
          </Route>
          <Route exact path="/cards">
            <Cards />
          </Route>
          <Route exact path = "/projects">
            <Projects/>
          </Route>
          <Route exact path = "/contact">
            <Contact/>
          </Route>
          <Route exact path = "/curiosity">
            <Curiosity/>
          </Route>
        </Switch>
      </Suspense>
      </Router>
    </div>
  );
}

export default App;
